import React, { useEffect, useState } from 'react';
import UI from '../../ui';
import Utils from '../../utils';
import { Instructions } from '../Instructions';
import { InboundStatus, WarehouseStatus } from '../Status';
import { ValidationErrors } from '../Validations';

const { WrappedDropdownWithLabel } = UI;
const { ShipFromManager } = Utils;

const WarehouseDropdown = ({
	onWarehouseChange,
	isMobile,
	updateInboundInstructions,
	inboundWarehouseId,
	inboundStatus,
	saveDefaultInboundSelection,
	validations,
	updateValidation,
}) => {
	const warehouses = ShipFromManager.ZorbitWarehouses;
	const [warehouseId, setWarehouseId] = useState(inboundWarehouseId);
	const [warehouseOptions, setWarehouseOptions] = useState(warehouses);
	const inboundWarehouse = warehouses.find(
		warehouse => warehouse.warehouseId === warehouseId
	);
	const disableWarehouse = [
		InboundStatus.Submitted,
		InboundStatus.InTransit,
		InboundStatus.Processing,
		InboundStatus.Completed,
		InboundStatus.Cancelled,
	].includes(InboundStatus[inboundStatus]);

	useEffect(() => {
		setWarehouseId(inboundWarehouseId);
	}, [inboundWarehouseId]);

	useEffect(() => {
		const updatedWarehouses = [];

		warehouses.forEach(warehouse => {
			if (
				warehouse.warehouseId !== '0' &&
				warehouse.status === WarehouseStatus.Active
			) {
				updatedWarehouses.push(warehouse);
			}
		});

		setWarehouseOptions(updatedWarehouses);
	}, [warehouses]);

	const validateWarehouse = selectedWarehouse => {
		const updatedValidations = validations;

		updatedValidations.warehouse = selectedWarehouse ? 1 : -1;
		updateValidation(updatedValidations);
	};

	const onDropdownBlur = () => {
		validateWarehouse(warehouseId);
	};

	const onWarehouseSelectionChange = warehouseSelection => {
		const selectedWarehouseId = warehouseSelection.value;
		const selectedWarehouse = warehouses.find(
			warehouse => warehouse.warehouseId === selectedWarehouseId
		);

		saveDefaultInboundSelection('warehouseId', selectedWarehouseId);
		saveDefaultInboundSelection('warehouse', selectedWarehouse.address);

		setWarehouseId(selectedWarehouseId);
		onWarehouseChange(
			{
				warehouseId: selectedWarehouseId,
				warehouse: selectedWarehouse.address,
			},
			validateWarehouse(selectedWarehouseId)
		);
	};

	const onDropdownFocus = () => {
		updateInboundInstructions(
			Instructions.headers.inbound.warehouse,
			Instructions.instructions.inbound.warehouse
		);
	};

	return (
		<div>
			{disableWarehouse && (
				<div className="read-only-label-container">
					<div className="read-only-label">Warehouse</div>
					<div className="read-only-text">
						{inboundWarehouse && inboundWarehouse.title
							? inboundWarehouse.title
							: ''}
					</div>
				</div>
			)}
			{!disableWarehouse && (
				<WrappedDropdownWithLabel
					name="warehousedropdown"
					label="Warehouse"
					isInputInvalid={validations.warehouse === -1}
					showErrorBelow={isMobile}
					errorMessage={ValidationErrors.warehouseRequired}
					uiElementConfig={{
						name: 'warehouse',
						value: warehouseId,
						placeholder: 'Select Warehouse',
						onChange: onWarehouseSelectionChange,
						onFocus: onDropdownFocus,
						onBlur: onDropdownBlur,
						options: warehouseOptions,
						optionLabel: 'title',
						optionValue: 'warehouseId',
						dataqa: 'warehouse',
					}}
				/>
			)}
		</div>
	);
};

export default WarehouseDropdown;
